
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Utensils, Coffee, ShoppingBag, Film } from 'lucide-react';
import type { ProductSilo } from '@/utils/types';

interface ProductSilosProps {
  onSelect: (silo: ProductSilo) => void;
}

const ProductSilos: React.FC<ProductSilosProps> = ({ onSelect }) => {
  const silos: Array<{
    id: ProductSilo;
    name: string;
    icon: React.ReactNode;
    color: string;
    bgColor: string;
    description: string;
  }> = [
    {
      id: 'restaurants',
      name: 'Restaurants',
      icon: <Utensils className="h-10 w-10" />,
      color: 'text-emerald-600',
      bgColor: 'bg-givgo-green',
      description: 'Fast food & dining'
    },
    {
      id: 'beverages',
      name: 'Beverages',
      icon: <Coffee className="h-10 w-10" />,
      color: 'text-amber-600',
      bgColor: 'bg-givgo-yellow',
      description: 'Coffee & drinks'
    },
    {
      id: 'convenience',
      name: 'Convenience',
      icon: <ShoppingBag className="h-10 w-10" />,
      color: 'text-blue-600',
      bgColor: 'bg-givgo-blue',
      description: 'Retail & pharmacy'
    },
    {
      id: 'entertainment',
      name: 'Entertainment',
      icon: <Film className="h-10 w-10" />,
      color: 'text-purple-600',
      bgColor: 'bg-givgo-light',
      description: 'Movies & gaming'
    }
  ];

  return (
    <div className="grid grid-cols-1 gap-6">
      {silos.map((silo) => (
        <Card 
          key={silo.id}
          className="cursor-pointer hover:shadow-md transition-all border-2 hover:border-givgo-purple overflow-hidden animate-fade-in"
          onClick={() => onSelect(silo.id)}
        >
          <div className={`h-3 ${silo.bgColor}`}></div>
          <CardContent className="p-8 flex items-center gap-6">
            <div className={`w-20 h-20 rounded-full ${silo.bgColor} flex items-center justify-center ${silo.color} shadow-md`}>
              {silo.icon}
            </div>
            <div className="space-y-2">
              <h3 className="font-semibold text-2xl">{silo.name}</h3>
              <p className="text-md text-muted-foreground">{silo.description}</p>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default ProductSilos;
